import { Trans } from "react-i18next";

interface IUnassignLicenseInstructions {
    entitlementId: string;
}

const UnassignLicenseInstructions:React.FC<IUnassignLicenseInstructions> = ({entitlementId}) => {
    return (
        <>
            <div className="mt-1">
                <p style={{ textAlign: 'center', marginBottom:'0px', fontSize:'14px', fontWeight:'400' }}>
                    <Trans
                        i18nKey="UnassignLicenseInstruction"
                        values={{ entitlementId: entitlementId}}
                        components={{ strong: <strong />, br: <br /> }}
                    />
                </p>
            </div>
        </>
    )
}
export default UnassignLicenseInstructions;